import React from 'react';
import type { MarketGroupingMode } from '../../utils/marketGroupUtils';
import MarketDashboardGroupingSwitch from './MarketDashboardGroupingSwitch';

type MarketDashboardSectionHeaderProps = {
  title: React.ReactNode;
  groupingMode: MarketGroupingMode;
  onGroupingModeChange: (mode: MarketGroupingMode) => void;
  groupingDisabled?: boolean;
  subtitle?: React.ReactNode;
};

const MarketDashboardSectionHeader: React.FC<MarketDashboardSectionHeaderProps> = ({
  title,
  groupingMode,
  onGroupingModeChange,
  groupingDisabled = false,
  subtitle,
}) => (
  <div style={{ marginBottom: subtitle ? '8px' : '16px' }}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap',
      }}
    >
      <h3
        style={{
          fontSize: '20px',
          fontWeight: '600',
          color: '#1a237e',
          margin: 0,
          fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flex: '1 1 auto',
          minWidth: 0,
        }}
      >
        {title}
      </h3>
      <MarketDashboardGroupingSwitch
        mode={groupingMode}
        onChange={onGroupingModeChange}
        disabled={groupingDisabled}
      />
    </div>
    {subtitle && (
      <p
        style={{
          margin: '8px 0 0 0',
          fontSize: '13px',
          color: '#666',
          lineHeight: 1.45,
        }}
      >
        {subtitle}
      </p>
    )}
    {groupingMode === 'cluster' && (
      <p
        style={{
          margin: subtitle ? '6px 0 0 0' : '8px 0 0 0',
          fontSize: '12px',
          color: '#888',
          lineHeight: 1.45,
        }}
      >
        Строки объединяют записи семейства с грейдами из диапазона кластера.
      </p>
    )}
  </div>
);

export default MarketDashboardSectionHeader;
